import { Injectable } from "@angular/core";
import { Router, UrlTree } from "@angular/router";
import { AuthService } from "./auth.service";

@Injectable({
  providedIn: "root"
})
export class AuthGuardService {

  constructor(private authService: AuthService, private router: Router) { }

  async ensureEnrolled(): Promise<boolean | UrlTree> {
    try {

      await this.authService.ensureHasClientAppSession();
      await this.authService.isEnrolled();

      return true;
    } catch (error) {
      if (error.status === 403) {
        return this.router.parseUrl("/sign-in");
      }

      if (error.status === 401) {
        await this.authService.login();
        return this.router.parseUrl("/");
      }

      throw error;
    }
  }
}
